import React from 'react';
import { Link } from 'react-router-dom';

const headerSrc = `${process.env.PUBLIC_URL}/logo-bookers.png`;
const footerSrc = `${process.env.PUBLIC_URL}/logo-bookers-footer.png`;

export function HeaderLogo({ className = '', link = true }) {
  const img = (
    <img
      src={headerSrc}
      alt="Bookers"
      className={`h-9 w-auto ${className}`.trim()}
      width={300}
      height={67}
      decoding="async"
    />
  );
  if (!link) return img;
  return (
    <Link to="/" className="inline-flex items-center select-none">
      {img}
    </Link>
  );
}

export function FooterLogo({ className = '' }) {
  return (
    <img
      src={footerSrc}
      alt="Bookers"
      className={`h-9 w-auto ${className}`.trim()}
      width={300}
      height={67}
      decoding="async"
    />
  );
}
